import CURRENCIES from '@stripe-internal/currencies';
export const DEFAULT_DECIMAL_LENGTH = 2;
const log10 = (n)=>Math.log(n) / Math.LN10;
export default function currencyToDecimalLength(currency, defaultLength = DEFAULT_DECIMAL_LENGTH) {
    const currencyData = CURRENCIES[currency || ''];
    if (currencyData === null || currencyData === void 0 ? void 0 : currencyData.subunit_to_unit) {
        return Math.round(log10(currencyData.subunit_to_unit));
    }
    return defaultLength;
}

//# sourceMappingURL=currencyToDecimalLength.js.map